import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'

class ContextButton extends PureComponent {
    handleOnClick = event => {
        const { offsetX = 0, offsetY = 0, setTarget = false, toolTip = false } = this.props

        let args = {
            x: event.clientX + offsetX,
            y: event.clientY + offsetY,
        }

        //temp solution to not include target
        if (setTarget) {
            const targetRect = event.target.getBoundingClientRect()
            args = Object.assign({}, args, {
                x: targetRect.left + document.body.scrollLeft,
                y: targetRect.top + document.body.scrollTop,
            })
        } else if (toolTip) {
            //tool tip target
            const target = ReactDOM.findDOMNode(this.refs.button)
            args = Object.assign({}, args, {
                x: target.offsetParent.offsetLeft + target.offsetLeft + target.clientWidth / 2,
                y: target.offsetParent.offsetTop + target.offsetTop + target.clientHeight / 2,
            })
        }

        this.props.onClick(args)
    }

    render() {
        return (
            <Button
                className={this.props.className}
                tabIndex={this.props.tabIndex}
                id={this.props.id}
                ref="button"
                keyboard={this.props.keyboard}
                keyboardCtrl={this.props.keyboardCtrl}
                onClick={this.handleOnClick}
                style={this.props.style}
                theme={this.props.theme}
                icon={this.props.icon}
                puresvg={this.props.puresvg}
                alt={this.props.alt}
            >
                {' '}
                {this.props.children}
            </Button>
        )
    }
}

export default connect()(ContextButton)
